<template>
  <v-container class="max-width-1200">

    <v-row>
      <v-col class="pb-0 headline text-uppercase">
        {{ $t('company.awards.title') }}
      </v-col>
    </v-row>
    <v-row>
      <v-col class="display-1">
        {{ $t('company.awards.subtitle')}}
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col class="swiper-container">
          <v-row class="swiper-control">
            <v-btn id="prev" name="prev" title="prev" text dark class="prev-slide swiper-button-prev"><v-icon>mdi-chevron-left</v-icon></v-btn>
            <v-btn id="next" name="next" title="next" text dark class="next-slide swiper-button-next"><v-icon>mdi-chevron-right</v-icon></v-btn>
          </v-row>
          <div class="swiper-wrapper timeline">
            <div class="swiper-slide" v-for="(item,index) in timeline" :key="index">
              <div class="timestamp">
                <span class="date">{{item.year}}</span>
              </div>
              <div class="status">
                <v-row class="pt-4">
                  <v-col
                    v-for="(subitem,index2) in item.list"
                    :key="index2"
                    cols="12"
                    class="px-0">
                    <v-row>
                      <v-col cols="12" class="pa-0">
                        <span>{{ $t(subitem.title) }}</span>
                      </v-col>
                      <v-col cols="12" class="pa-0 font-size-xs">
                        <span>{{ $t(subitem.text) }}</span>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </div>
            </div>
          </div>

      </v-col>
    </v-row>

  </v-container>
</template>

<script>
  import DataComponentBase from '@/commons/DataComponentBase';

  export default {
    name: 'Awards',
    extends: DataComponentBase,

    data: () => ({
      timeline: [
        { icon: "mdi-duck", class: "text-left",  year: "2005",
          list: [
            { title: "company.awards.01.title", text: "company.awards.01.text", link: "" },
            // { title: "company.awards.02.title", text: "company.awards.02.text", link: "" },
            // { title: "company.awards.03.title", text: "company.awards.03.text", link: "" },
          ]
        },
        { icon: "mdi-duck", class: "text-right",  year: "2007",
          list: [
            { title: "company.awards.04.title", text: "company.awards.04.text", link: "" },
            // { title: "company.awards.05.title", text: "company.awards.05.text", link: "" },
          ]
        },
        { icon: "mdi-duck", class: "text-left",  year: "2008, 2009",
          list: [
            { title: "company.awards.06.title", text: "company.awards.06b.text", link: "" },
          ]
        },
        // { icon: "mdi-duck", class: "text-left",  year: "2008",
        //   list: [
        //     { title: "company.awards.06.title", text: "company.awards.06.text", link: "" },
        //   ]
        // },
        // { icon: "mdi-duck", class: "text-right",  year: "2009",
        //   list: [
        //     { title: "company.awards.07.title", text: "company.awards.07.text", link: "" },
        //   ]
        // },
        // { icon: "mdi-duck", class: "text-left",  year: "2011",
        //   list: [
        //     { title: "company.awards.08.title", text: "company.awards.08.text", link: "" },
        //     { title: "company.awards.09.title", text: "company.awards.09.text", link: "" },
        //   ]
        // },
        { icon: "mdi-duck", class: "text-right",  year: "2012",
          list: [
            { title: "company.awards.10.title", text: "company.awards.10.text", link: "" },
          ]
        },
        // { icon: "mdi-duck", class: "text-left",  year: "2013",
        //   list: [
        //     { title: "company.awards.11.title", text: "company.awards.11.text", link: "" },
        //     { title: "company.awards.12.title", text: "company.awards.12.text", link: "" },
        //   ]
        // },
        { icon: "mdi-duck", class: "text-right",  year: "2014",
          list: [
            { title: "company.awards.13.title", text: "company.awards.13.text", link: "" },
            { title: "company.awards.14.title", text: "company.awards.14.text", link: "" },
          ]
        },
        { icon: "mdi-duck", class: "text-left",  year: "2015",
          list: [
            { title: "company.awards.15.title", text: "company.awards.15.text", link: "" },
            { title: "company.awards.16.title", text: "company.awards.16.text", link: "" },
            { title: "company.awards.17.title", text: "company.awards.17.text", link: "" },
          ]
        },
        { icon: "mdi-duck", class: "text-right",  year: "2017",
          list: [
            { title: "company.awards.18.title", text: "company.awards.18.text", link: "" },
          ]
        },
        { icon: "mdi-duck", class: "text-left",  year: "2018",
          list: [
            { title: "company.awards.19.title", text: "company.awards.19.text", link: "" },
          ]
        },
        { icon: "mdi-duck", class: "text-right",  year: "2020",
          list: [
            { title: "company.awards.20.title", text: "company.awards.20.text", link: "" },
          ]
        },
        { icon: "mdi-duck", class: "text-right",  year: "2021",
          list: [
            { title: "company.awards.21.title", text: "company.awards.21.text", link: "" },
          ]
        },
      ],

    }),

    methods: {

    },
    mounted() {
      var swiper = new Swiper('.swiper-container', {
        initialSlide: 6,
        // pagination: '.swiper-pagination',
        slidesPerView: 4,
        // paginationClickable: true,
        grabCursor: true,
        // paginationClickable: true,
        // nextButton: '.next-slide',
        // prevButton: '.prev-slide',
        navigation: {
          nextEl: '.next-slide',
          prevEl: '.prev-slide',
        },
        // autoplay: {
        //   delay: 5000,
        // },
      });
    }
  }
</script>
